module.exports = __webpack_public_path__ + "static/img/安徽五一学堂_logo.eb393e53.png";